// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"68443db1","453":"41a9cd86","834":"ea3e09a9"}[chunkId] + ".chunk.js";
};